import ButtonView from './button/ButtonView'
import ButtonText from './button/ButtonText'
import WebAuthnSetupAcceptButtonContainer from './button/WebAuthnSetupAcceptButtonContainer'
import LogisterFormSocialButtonsContainer from './logister-page/LogisterFormSocialButtonsContainer'
import LogisterFormRegisterLink from './logister-page/LogisterFormRegisterLink'
import LogisterFormSubmitButtonContainer from './logister-page/LogisterFormSubmitButtonContainer'
import Bold from '../Bold'
import SmallNote from './SmallNote'
import EmailVerifiedSuccessMessage from './EmailVerifiedSuccessMessage'

export default {
  Bold,
  ButtonText,
  ButtonView,
  LogisterFormRegisterLink,
  LogisterFormSocialButtonsContainer,
  LogisterFormSubmitButtonContainer,
  SmallNote,
  EmailVerifiedSuccessMessage,
  WebAuthnSetupAcceptButtonContainer,
}
